/**
 * Asset resolution for the insurance coverage checker. Service icons + check
 * mark are local (public/insurance-checker/); insurer logos come from the CMS.
 */

const ASSET_BASE = "/insurance-checker"

/** Resolve a local coverage-checker asset path under public/insurance-checker/. */
export function assetUrl(path: string): string {
  if (path.startsWith("http")) return path
  return `${ASSET_BASE}${path}`
}

/** Reads the logo URL off an insurer doc fetched from the CMS (Vercel Blob /
 * CMS media URL — already absolute, resolved in insurer-cms.ts). */
export function getInsurerLogoUrl(
  insurer: { logo?: { url: string } | null } | undefined
): string | undefined {
  return insurer?.logo?.url || undefined
}

/** Service icon config — keyed by service ID. A finite set of brand assets
 * shipped locally. */
export function getServiceIcon(
  id: string
): { icon: string; bg: string; border?: boolean; photo?: boolean } | undefined {
  const config = SERVICE_ICON_CONFIGS[id]
  if (!config) return undefined
  return { ...config, icon: assetUrl(config.icon) }
}

const SERVICE_ICON_CONFIGS: Record<
  string,
  { icon: string; bg: string; border?: boolean; photo?: boolean }
> = {
  "core-mri": { icon: "/logos/pkg-core.svg", bg: "rgb(226, 230, 167)" },
  "advanced-mri": { icon: "/logos/pkg-advanced.svg", bg: "rgb(195, 213, 244)" },
  "pro-mri": { icon: "/logos/pkg-pro.svg", bg: "rgb(224, 204, 229)" },
  "blood-test": {
    icon: "/logos/pkg-blood.png",
    bg: "rgb(240, 237, 234)",
    photo: true,
  },
  "membership-group": {
    icon: "/logos/pkg-membership.svg",
    bg: "#48214a",
  },
}
